import * as React from 'react';
import type { SVGProps } from 'react';
const SvgYqhy = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 48 48" {...props}>
    <path
      d="M22.319 26.033a9.207 9.207 0 0 1-9.3-9.109 9.3 9.3 0 0 1 18.6 0 9.207 9.207 0 0 1-9.3 9.109Zm.4 5.818c1.515 0 2.727-4.752 4.01-4.489.331.068.647.15.963.232a9.448 9.448 0 0 0 1.134 12.136 152.96 152.96 0 0 1-6.911.135c-4.954 0-14.559-.49-14.559-2.293V34.08c0-1.018 3.59-5.219 10.423-6.652 1.442-.302 3.221 4.423 4.944 4.423ZM35.3 40.192a7.37 7.37 0 1 1 7.37-7.369 7.37 7.37 0 0 1-7.37 7.369Zm3.693-8.9h-2.115v-2.11a1.554 1.554 0 1 0-3.108 0v2.113h-2.112a1.554 1.554 0 1 0 0 3.108h2.113v2.113a1.554 1.554 0 0 0 3.108 0V34.4h2.113a1.554 1.554 0 0 0-.001-3.105Z"
      style={{
        fill: 'currentColor',
				fillRule: 'evenodd',
      }}
    />
  </svg>
);
export default SvgYqhy;
